import script from "./CtaBand.vue?vue&type=script&setup=true&lang=js"
export * from "./CtaBand.vue?vue&type=script&setup=true&lang=js"

import "./CtaBand.vue?vue&type=style&index=0&id=bbd109a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbd109a8"]])

export default __exports__